import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import ptBundled from '../../../assets/i18n/pt.json';
import enBundled from '../../../assets/i18n/en.json';

/** Traduções completas embutidas no bundle; usadas para o portal todo (incl. dev/staging) sem depender de HTTP. */
const BUNDLED_TRANSLATIONS: Record<string, Record<string, unknown>> = {
  pt: ptBundled as Record<string, unknown>,
  en: enBundled as Record<string, unknown>,
};

/** Exposto para o LanguageService pré-carregar pt/en e garantir que pt funcione quando o browser está em português. */
export function getBundledTranslations(lang: string): Record<string, unknown> {
  const key = lang?.startsWith('pt') ? 'pt' : lang?.startsWith('en') ? 'en' : 'pt';
  return BUNDLED_TRANSLATIONS[key] ?? BUNDLED_TRANSLATIONS['pt'];
}

export class TranslateFallbackLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  /**
   * Devolve sempre o bundle (já embutido no app) para o idioma estar preenchido antes do primeiro render.
   * Assim não dependemos do HTTP em dev/staging e a deteção do navegador resolve para pt ou en corretamente.
   */
  getTranslation(lang: string): Observable<Record<string, unknown>> {
    return of(getBundledTranslations(lang));
  }
}

export function createTranslateFallbackLoader(http: HttpClient): TranslateLoader {
  return new TranslateFallbackLoader(http);
}
